import React, { useEffect, useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faCalendarCheck,
  faCreditCard,
  faGift,
  faHeart,
  faComments,
  faCog
} from '@fortawesome/free-solid-svg-icons';
import '../../styles/UserCenter.css';

const UserCenterActions = () => {
  const navigate = useNavigate();
  const [userData, setUserData] = useState(null);
  
  useEffect(() => {
    // 获取用户数据
    let storedUser = localStorage.getItem('userData');
    if (!storedUser) {
      storedUser = localStorage.getItem('user');
    }
    
    if (storedUser) {
      try {
        setUserData(JSON.parse(storedUser));
      } catch (err) {
        console.error('Error parsing user data', err);
      }
    }
  }, []);
  
  const getUserProfile = () => {
    if (userData && userData.id) {
      return `/users/${userData.id}`;
    }
    return '/user-center';
  };
  
  return (
    <div className="user-actions-section">
      <h2 className="section-title">快捷功能</h2>
      <div className="user-actions-grid">
        <Link to="/appointments" className="action-card">
          <div className="action-icon">
            <FontAwesomeIcon icon={faCalendarCheck} />
          </div>
          <div className="action-name">我的预约</div>
        </Link>
        
        <Link to="/recharge" className="action-card">
          <div className="action-icon">
            <FontAwesomeIcon icon={faCreditCard} />
          </div>
          <div className="action-name">账户充值</div>
        </Link>
        
        <Link to="/gift-cards" className="action-card">
          <div className="action-icon">
            <FontAwesomeIcon icon={faGift} />
          </div>
          <div className="action-name">礼品卡</div>
        </Link>
        
        <Link to="/favorites" className="action-card">
          <div className="action-icon">
            <FontAwesomeIcon icon={faHeart} />
          </div>
          <div className="action-name">我的收藏</div>
        </Link>
        
        <Link to={getUserProfile()} className="action-card">
          <div className="action-icon">
            <FontAwesomeIcon icon={faComments} />
          </div>
          <div className="action-name">我的评价</div>
        </Link>
        
        <Link to={getUserProfile()} className="action-card">
          <div className="action-icon">
            <FontAwesomeIcon icon={faCog} />
          </div>
          <div className="action-name">设置</div>
        </Link>
      </div>
    </div>
  );
};

export default UserCenterActions; 